module.exports = __webpack_public_path__ + "static/media/home_15.20b94d26.jpg";